import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from '../app/login/login.component';
import { VisitgridComponent } from '../app/visitgrid/visitgrid.component';
import { VisitgriddetailsComponent } from '../app/visitgriddetails/visitgriddetails.component';
import { PdfviewerComponent } from '../app/pdfviewer/pdfviewer.component';
import { authGuard } from './_helpers';


const routes: Routes = [
  { path: '', redirectTo:'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'visitgrid', component: VisitgridComponent,canActivate : [authGuard] },
  { path: 'visitgriddetails', component: VisitgriddetailsComponent,canActivate : [authGuard] },
  { path: 'pdfviewer', component: PdfviewerComponent,canActivate : [authGuard] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
